import { Box, Button, Grid, styled, Typography } from '@material-ui/core';
import DirectImage from '../DirectImage';

// // component props interface
// export interface CarouselCard1Props {
//   heading?: string
//   body?: string
// }
// styled component
const StyledBox = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '.title': {
    fontSize: 40,
    marginTop: 0,
    marginBottom: '1.35rem',
    lineHeight: 1.2
  },
  [theme.breakpoints.up('sm')]: {
    '.grid-item': {
      minHeight: 424,
      display: 'flex',
      alignItems: 'baseline',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
    paddingLeft: 0,

    '.title': {
      fontSize: 32
    }
  },
  [theme.breakpoints.down('xs')]: {
    '.title': {
      fontSize: 16
    },
    '.title + *': {
      fontSize: 13
    },
    '.button-link': {
      height: 36,
      padding: '0 1.5rem',
      fontSize: 13
    }
  }
}));

export default function CarouselCard1() {
  // const { single_product, fetchSingleProduct, fetchProductImages } = useProductsContext()

  return (
    <StyledBox>
      <Grid container spacing={3} alignItems="center" justifyContent="center">
        <Grid item className="grid-item" sm={5} xs={12}>
          <h3 className="title">Membership</h3>
          <Typography color="secondary.main" mb={2.7}>
            Knowing who and where our members are to ensure services are provided based on
            demographic distributions.
          </Typography>
        </Grid>
        <Grid item sm={5} xs={12}>
          <DirectImage
            src="/assets/slider/slider01.jpg"
            alt="cocktaildress"
            sx={{
              display: 'block',
              mx: 'auto',
              maxHeight: 400,
              maxWidth: '100%'
            }}
          />
        </Grid>
      </Grid>
    </StyledBox>
  );
}
